export default __webpack_public_path__ + "static/media/boschsans_regular.b54607f2.woff";